import React from 'react'

import computerlearn from "../images/computer-learn.jpg";



function About() {
    return (
        <div>
  
            <div className="album py-0">
                <div className="container">

                    <div className="card-body">
                        <div className='welcometext'>
                            <h1 className="card-title mb-0"><b>About us</b></h1>
                            <div className="col-md-2">
                                <hr style={{ color: "#1D4D93" }} />
                            </div>
                        </div>
                        <div className="album py-0">
                            <div className="container">
                                <div className="row">

                                    <div className="col-md-7 mt-3">
                                        <div className='mission'>
                                            <h3 style={{ color: "#1D4D93" }} className='mb-2'>Welcome to <b style={{color:"#ED1B24"}}>Astha Digital Services </b>– Computer Course Training Institute.
</h3>
                                           <p style={{color:"#1D4D93"}} className='mb-2'>Dear Visitors,</p>
                

                                    <p className='justify mb-2'>Astha Digital Services is a trusted computer training institute dedicated to empowering students, job seekers, and professionals with practical digital skills. Our mission is to provide quality computer education that is easy to understand, industry-relevant, and career-focused.</p>
                                    <p className='justify mb-1'>We offer a wide range of computer courses designed to meet today’s technological demands, from basic computer knowledge to advanced digital skills. Our experienced trainers focus on hands-on learning, real-world applications, and personal attention to ensure every student gains confidence and competence.</p>
                                    <p className='justify mb-1'>At Astha Digital Services, we believe that the right knowledge can open the door to better career opportunities and a brighter future. We are committed to helping our students grow, succeed, and stay ahead in the digital world.</p>
                                    <p style={{color:"#1D4D93"}}><b>Learn. Grow. Succeed — with Astha Digital Services.</b></p>
                            
                                        </div>
                                    </div>
                                    <div className="col-md-5 mt-3">

                                        <img src={computerlearn} className="card-img-top" alt="computerlearn"/>


                                    </div>





                                </div>
                            </div>
                        </div>
                        <br />






                    </div>
                </div>
            </div>
            <br />


        </div>
    )
}

export default About